import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { TICKETS_URL, COLAB_OFFICIAL, officialUrlForProduction } from "../data/reviews";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  // Contextual official URL: on a /productions/:slug page, deep-link to that show.
  const prodMatch = location.pathname.match(/^\/productions\/([^/]+)$/);
  const officialHref = prodMatch
    ? officialUrlForProduction(prodMatch[1])
    : COLAB_OFFICIAL;
  const officialLabel = prodMatch ? "On COLAB ↗" : "COLAB Site ↗";

  return (
    <nav
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-[80] transition-colors duration-500 ${
        scrolled ? "bg-[#050505]/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-14 lg:px-20 py-6 md:py-8 gap-6 md:gap-10 border-b border-white/5">
        <NavLink
          to="/"
          className="flex items-center gap-4 shrink-0"
          data-testid="nav-logo"
          aria-label="COLAB Theatre — home"
        >
          <img
            src="https://static1.squarespace.com/static/525bd8b5e4b0daa056d3ae62/t/609bdba60d591d31a96d63e6/1620827046291/COLAB+LOGO+BLACK+AND+WHITE+IMMERSIVE+THEATRE+LONDON.jpg"
            alt="COLAB Theatre — Best Immersive Theatre in London"
            className="h-10 md:h-11 w-auto object-contain"
          />
          <span className="hidden xl:block text-[10px] uppercase tracking-[0.3em] font-mono text-white/40 border-l border-white/15 pl-4 leading-tight">
            Best Immersive
            <br />
            Theatre · London
          </span>
        </NavLink>
        <ul className="flex items-center gap-5 md:gap-8 lg:gap-10">
          <li className="hidden md:block">
            <NavLink
              to="/"
              data-testid="nav-home"
              className={({ isActive }) =>
                `link-hover text-xs uppercase tracking-[0.25em] ${
                  isActive ? "text-white" : "text-white/60 hover:text-white"
                }`
              }
              end
            >
              Home
            </NavLink>
          </li>
          <li className="hidden md:block">
            <NavLink
              to="/reviews"
              data-testid="nav-reviews"
              className={({ isActive }) =>
                `link-hover text-xs uppercase tracking-[0.25em] ${
                  isActive ? "text-white" : "text-white/60 hover:text-white"
                }`
              }
            >
              Reviews
            </NavLink>
          </li>
          <li className="hidden lg:block whitespace-nowrap">
            <a
              href="/api/press-kit.pdf"
              data-testid="nav-press-kit"
              className="link-hover text-xs uppercase tracking-[0.25em] text-white/60 hover:text-white"
            >
              Press Kit
            </a>
          </li>
          <li className="hidden lg:block whitespace-nowrap">
            <a
              href={officialHref}
              target="_blank"
              rel="noreferrer"
              data-testid="nav-official"
              className="link-hover text-xs uppercase tracking-[0.25em] text-white/60 hover:text-white"
            >
              {officialLabel}
            </a>
          </li>
          <li>
            <a
              href={TICKETS_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="nav-book"
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-white text-white text-[10px] md:text-xs uppercase tracking-[0.25em] hover:bg-white hover:text-black transition-colors whitespace-nowrap"
            >
              Book <span className="hidden md:inline">tickets</span> →
            </a>
          </li>
        </ul>
      </div>
      {location.pathname !== "/" && (
        <div className="px-6 md:px-14 lg:px-20 py-3 text-[10px] uppercase tracking-[0.3em] font-mono text-white/40 border-b border-white/5">
          Home / Immersive Theatre Reviews — Best Immersive Theatre in London
        </div>
      )}
    </nav>
  );
}
